import React, { useEffect, useState } from 'react';
import usePlacesAutocomplete, { getGeocode, getLatLng, getZipCode } from 'use-places-autocomplete';
import useOnclickOutside from 'react-cool-onclickoutside';
import TextBox from '../TextBox';
import './index.scss';

const GoogleAutoComplete = ({ defaultAddress, className, onComplete, label, placeholder }) => {
    const [address, setAddress] = useState('');
    const {
        ready,
        // value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: {
                country: ['us'],
            },
            // types: ['(cities)'],
        },
        debounce: 300,
    });

    useEffect(() => {
        setAddress(defaultAddress);
    }, [defaultAddress]);

    const ref = useOnclickOutside(() => {
        clearSuggestions();
    });

    const handleInput = (value) => {
        setAddress(value);
        setValue(value);
    };

    const handleSelect = (data) => {
        const { description, terms } = data;

        const state = terms[terms.length - 2]?.value;
        const city = terms[terms.length - 3]?.value;
        return () => {
            setValue(description, false);
            setAddress(description);
            clearSuggestions();
            getGeocode({ address: description })
                .then(async (results) => {
                    const zipCode = await getZipCode(results[0], false);
                    const location = await getLatLng(results[0]);
                    onComplete({
                        address: description,
                        state,
                        city,
                        zipCode,
                        location,
                    });
                })
                .catch((error) => {});
        };
    };

    const renderSuggestions = () =>
        data.map((suggestion) => {
            const {
                place_id,
                structured_formatting: { main_text, secondary_text },
            } = suggestion;

            return (
                <li key={place_id} onClick={handleSelect(suggestion)}>
                    <div className="font-weight-bold">{main_text}</div>
                    <small>{secondary_text}</small>
                </li>
            );
        });

    return (
        <div className={`position-relative ${className || ''}`} ref={ref}>
            <TextBox
                label={label || 'Address'}
                id="address"
                name="address"
                type="text"
                disabled={!ready}
                value={address}
                placeholder={placeholder ?? 'Larkspur, CA 94939'}
                onChange={handleInput}
                validationOption={{
                    check: true,
                    required: true,
                    showMsg: false,
                }}
            />
            {status === 'OK' && <ul className="autocomplete-list">{renderSuggestions()}</ul>}
        </div>
    );
};

export default GoogleAutoComplete;
